export default "__VITE_PUBLIC_ASSET__ff9b1bbe__"